module fdm.flightSegment {

    class EcmDiagnosticsExportModalController {
        public static $inject = ['$scope', '$http', 'exportLink', 'seedQuery', 'clientInfoService', 'actionService'];

        constructor(
            private $scope: any,
            private $http: ng.IHttpService,
            private exportLink: dg.restfulApi.Link,
            private seedQuery: dg.domain.IDomainObject,
            private clientInfoService: dg.clients.ClientInfoService,
            private actionService: dg.actions.ActionService
        ) {
            $scope.loading = false;
            $scope.loadingForm = true;
            $scope.error = '';
            $scope.loadError = '';
            $scope.reportType = 'diagnostics';
            $scope.exportQuery = null;

            $scope.exportReport = () => this.exportReport();
            this.loadDiagnosticsQuery();
        }

        private loadDiagnosticsQuery(): void {
            var scope = this.$scope;
            var templateHref = this.queryTemplateHrefFromExportLink(this.exportLink.href);
            var templateParams = this.templateBindingParamsFromSeed(this.seedQuery);
            this.actionService.getAction(templateHref, templateParams).then((q: dg.domain.queries.IQueryAction) => {
                this.applySeedFromEcmPage(q);
                scope.exportQuery = q;
                scope.loadingForm = false;
            }, () => {
                scope.loadingForm = false;
                scope.loadError = 'Failed to load export parameters.';
            });
        }

        /** Rel.Export href targets .../result (runs the handler). The query shell + metadata comes from GET ... (QueryController.Instantiate). */
        private queryTemplateHrefFromExportLink(href: string): string {
            if (!href) {
                return href;
            }
            var qIdx = href.indexOf('?');
            var path = qIdx >= 0 ? href.substring(0, qIdx) : href;
            var qs = qIdx >= 0 ? href.substring(qIdx) : '';
            var newPath = path.replace(/\/result\/?$/i, '');
            return newPath + qs;
        }

        private templateBindingParamsFromSeed(seed: dg.domain.IDomainObject): any {
            if (!seed) {
                return undefined;
            }
            var s = seed as any;
            var p: any = {};
            if (s.aircraft && s.aircraft.id) {
                p['aircraft.id'] = s.aircraft.id;
            }
            if (s.legDate && s.legDate.min != null && s.legDate.max != null) {
                p['legDate.min'] = this.toYmd(s.legDate.min);
                p['legDate.max'] = this.toYmd(s.legDate.max);
            }
            return Object.keys(p).length ? p : undefined;
        }

        private toYmd(value: any): string {
            var d = new Date(value);
            return d.getFullYear() + '-' +
                ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
                ('0' + d.getDate()).slice(-2);
        }

        private applySeedFromEcmPage(reportQuery: any): void {
            var seed = this.seedQuery as any;
            if (!seed || !reportQuery) {
                return;
            }
            if (seed.aircraft) {
                reportQuery.aircraft = dgUtils.ObjectHelperService.mergeDeep({}, seed.aircraft);
            }
            if (seed.legDate && seed.legDate.min != null && seed.legDate.max != null) {
                reportQuery.legDate = {
                    min: new Date(seed.legDate.min),
                    max: new Date(seed.legDate.max)
                };
            }
        }

        private getBaseUrl(): string {
            var clientId = this.clientInfoService.getClientInfoResolved().clientId;
            return '/api/v1/' + clientId + '/flight-segment';
        }

        private exportReport(): void {
            var scope = this.$scope;
            scope.loading = true;
            scope.error = '';

            var isExcel = scope.reportType === 'excel';
            var endpoint = isExcel
                ? '/ecm-excel-diagnostics-report/result'
                : '/ecm-diagnostics-report/result';
            var acceptHeader = isExcel
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/zip';
            var fileName = isExcel ? 'Diagnostics_Report.xlsx' : 'Diagnostics_Report.zip';

            var params = this.actionService.getQueryParams(scope.exportQuery);

            this.$http({
                method: 'GET',
                url: this.getBaseUrl() + endpoint,
                params: params,
                headers: { 'Accept': acceptHeader },
                responseType: 'blob'
            }).then((result: any) => {
                this.downloadBlob(result.data, fileName, acceptHeader);
                scope.loading = false;
                scope.$dismiss();
            }, (err: any) => {
                scope.loading = false;
                this.setExportHttpError(scope, err);
            });
        }

        private setExportHttpError(scope: any, err: any): void {
            var fallback = 'Failed to generate diagnostics report.';
            if (err && err.data instanceof Blob) {
                var reader = new FileReader();
                var self = this;
                reader.onloadend = function () {
                    scope.$apply(function () {
                        scope.error = self.messageFromErrorPayload(reader.result as string) || fallback;
                    });
                };
                reader.onerror = function () {
                    scope.$apply(function () {
                        scope.error = fallback;
                    });
                };
                reader.readAsText(err.data);
            } else {
                scope.error = this.messageFromErrorPayload(err && err.data) || fallback;
            }
        }

        /**
         * Digmo ErrorResult JSON: generic summary in `message`, real text often in `data.detailedMessage`
         * (see DefaultErrorResponseBuilder / ErrorHandlingMiddleware).
         */
        private messageFromErrorPayload(raw: any): string {
            var j: any = null;
            if (raw == null) {
                return null;
            }
            if (typeof raw === 'object' && !(raw instanceof Blob)) {
                j = raw;
            } else if (typeof raw === 'string') {
                try {
                    j = JSON.parse(raw);
                } catch (e) {
                    return null;
                }
            } else {
                return null;
            }

            var fromNested = this.detailedMessageFromErrorData(j.data);
            if (fromNested) {
                return fromNested;
            }
            if (j.message && typeof j.message === 'string') {
                var m = j.message.trim();
                if (m && !this.isGenericApiErrorSummary(m)) {
                    return m;
                }
            }
            return null;
        }

        private detailedMessageFromErrorData(data: any): string {
            if (!data || typeof data !== 'object') {
                return null;
            }
            var dm = data.detailedMessage;
            if (typeof dm !== 'string' || !dm.trim()) {
                return null;
            }
            var lines = dm.split('\n');
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i].trim();
                if (line.length > 0) {
                    return line;
                }
            }
            return null;
        }

        private isGenericApiErrorSummary(m: string): boolean {
            var t = m.toLowerCase().replace(/\s+/g, ' ').trim();
            return t === 'an error has occurred' || t === 'an error has occured';
        }

        private downloadBlob(data: Blob, fileName: string, contentType: string): void {
            var blob = new Blob([data], { type: contentType });
            var url = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    }

    angular.module('fdm.flightSegment')
        .controller('EcmDiagnosticsExportModalController', EcmDiagnosticsExportModalController);
}
